// extracted by mini-css-extract-plugin
export var fadeIn = "_j5-1";
export var modalContent = "_j5-3";
export var overlay = "_j5-0";
export var popoverContent = "_j5-2";
export var results = "_j5-5";
export var searchInputWrapper = "_j5-4";